import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';
import activityTextClass from 'constants/ActivityTheme';

const PageWrap = styled.div.attrs(() => {
  const classNamesToAdd = ['w-full', 'relative', '-mt-80'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;
const TitleWrap = styled.div.attrs(() => {
  const classNamesToAdd = [
    'w-full',
    'container',
    'text-white',
    'mx-auto',
    'px-4',
    'md:px-8',
    'pb-6',
    'md:pb-8',
    'pt-32',
    'md:pb-12',
    'md:pt-20',
    'lg:pt-10',
    'lg:pb-16',
    'flex',
    'flex-col',
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;
const ContentWrap = styled.div.attrs(() => {
  const classNamesToAdd = ['bg-white', 'rounded-t-base', 'md:rounded-t-3xl'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

const LabelWrap = styled.div.attrs(({ themeIcon }) => {
  const classNamesToAdd = [
    'h-11',
    'w-11',
    'md:h-13',
    'md:w-13',
    'mr-4',
    'bg-white',
    'rounded-lg',
    'flex',
    'flex-col',
    'justify-center',
    'items-center',
    activityTextClass[themeIcon],
  ];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})``;

export { PageWrap, TitleWrap, ContentWrap, LabelWrap };
